import MLink from './MLink.vue';

MLink.install = (app) => {
  app.component('MLink', MLink);
};

export { MLink };
